import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// A homepage é a página do agente, mas o chat dela (com o CopilotKit) só é
// baixado pelo @defer depois que o authGuard (que espera o Firebase) libera a
// rota. Disparar o import aqui adianta o download para logo após os chunks
// iniciais, em paralelo com o bootstrap e a autenticação; o @defer reaproveita
// o mesmo módulo. Falhas são ignoradas porque o @defer faz o próprio import.
import('./app/shared/components/datasafra-agent-chat/datasafra-agent-chat.component').catch(
  () => undefined,
);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
